import { TripTypes } from '@model/common/tours/trip-types';

export const NO_AIRPORT_CODE = '999';

export const ANY_AIRPORT_CODE = '998';

export const NoAirportTripTypes = [TripTypes.PRIVATE_TOURS];
